export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      howItWorks: 'Comment ça marche ?',
      offers: 'Nos offres',
      about: 'À propos',
      contact: 'Contact',
      cta: 'Je Rejoins le Club ProbaWins'
    },
    logo: {
      tagline: 'Jouez malin'
    },
    hero: {
      title: 'EuroMillions : Ne jouez plus au hasard, jouez malin avec ProbaWins',
      subtitle: 'La chance sourit à ceux qui maîtrisent les statistiques.',
      description: "Chez ProbaWins, on ne vend pas de rêve, on vous donne des grilles optimisées, basées sur des méthodes fiables.",
      tagline: 'La chance se calcule, alors pourquoi attendre ?',
      cta: 'Je découvre ma stratégie gagnante'
    },
    section1: {
      title: 'Pilotez vos jeux comme un pro, avec les bonnes données.',
      subtitle: 'Suivez les derniers tirages, affinez vos grilles et prenez des décisions basées sur les statistiques, pas sur la chance.',
      feature1: 'Chaque grille a une logique. Notre système analyse les tirages passés pour sélectionner les combinaisons qui ont le plus de potentiel.',
      feature2: 'Des grilles optimisées livrées chaque semaine dans votre boîte mail. Recevez automatiquement vos combinaisons prêtes à jouer',
      feature3: 'Une solution simple, fiable et sans engagement pour les joueurs qui veulent maximiser leurs chances.'
    },
    testimonials: {
      title: 'Ils ont misé sur les chiffres. Ils ne jouent plus au hasard',
      subtitle: 'Des joueurs exigeants, rationnels ou curieux. Tous ont trouvé dans ProbaWins une méthode qui change la donne.',
      testimonial1: {
        text: "C'est simple : je prends plus de plaisir, parce que je joue avec la tête. Et je ne gaspille plus mes grilles.",
        name: 'Nadine',
        role: 'Retraitée'
      },
      testimonial2: {
        text: "J'étais sceptique, j'ai testé, j'ai changé d'avis. ProbaWins, c'est l'anti-hasard. Faisons confiance aux chiffres!",
        name: 'Jean',
        role: 'Banquier'
      },
      testimonial3: {
        text: 'Ce service m\'a redonné l\'envie de tenter ma chance… mais cette fois, avec des vraies chances.',
        name: 'Jenni',
        role: 'Secrétaire'
      },
      testimonial4: {
        text: 'J\'aime optimiser. Dans mon business comme dans mes jeux. ProbaWins coche toutes les cases.',
        name: 'Mathias',
        role: 'Entrepreneur'
      },
      testimonial5: {
        text: 'J\'ai compris que si je voulais gagner plus, je devais jouer mieux. Leur méthode m\'a bluffé.',
        name: 'Nicole',
        role: 'Mère au foyer'
      }
    },
    testOffer: {
      title: 'Testez ProbaWins sur un tirage — et jugez par vous-même.',
      description: 'Recevez votre grille optimisée pour le prochain tirage de l\'EuroMillions, générée selon nos probabilités exclusives. Pas d\'abonnement, pas d\'engagement : juste un test, et des chiffres qui parlent.',
      amount: '29.99',
      currency: '€',
      cta: 'Je tente ma chance pour un tirage'
    },
    howItWorks: {
      title: 'Statistiques. Précision. Résultats.',
      subtitle: 'En 3 étapes simples, passez du joueur au stratège. ProbaWins vous guide pour jouer plus malin – fini le hasard. De toute façon, vous allez jouer. Autant le faire intelligemment.',
      step1: {
        title: 'Choisissez votre pack',
        description: 'Essai d\'un tirage unique ou abonnement ? Vous décidez. Nous, on prépare vos meilleures grilles.'
      },
      step2: {
        title: 'Recevez vos grilles optimisées',
        description: 'Des combinaisons calculées à partir de milliers de tirages. Livrées par e-mail, prêtes à être jouées.'
      },
      step3: {
        title: 'Jouez avec méthode (et sérénité)',
        description: 'Chaque grille repose sur une vraie stratégie. Pas d\'impro, que de la logique. Et beaucoup plus de plaisir à jouer.'
      },
      cta: 'Je choisis ma stratégie'
    },
    emailSection: {
      title: 'Chaque semaine, vos grilles directement dans votre boîte mail.',
      description: 'Pas d\'appli, pas de login. Vous recevez nos meilleures probabilités, prêtes à être jouées. Où que vous soyez, sur n\'importe quel appareil.'
    },
    whyChoose: {
      title: 'Pourquoi des centaines de joueurs choisissent ProbaWins chaque semaine.',
      subtitle: 'Vous jouez déjà. Autant le faire avec méthode, sans perdre de temps ni d\'argent. ProbaWins simplifie tout pour que chaque grille compte vraiment.',
      feature1: {
        title: 'Méthode Probabiliste',
        description: 'Repose sur des analyses fiables et sérieuses.'
      },
      feature2: {
        title: 'Livraison chaque semaine',
        description: 'Le Mardi et/ou le vendredi selon l\'offre choisie.'
      },
      feature3: {
        title: 'Aucun engagement',
        description: 'Le minimum recommandé est de 3 mois, mais vous êtes libre d\'arrêter à tout moment.'
      },
      feature4: {
        title: 'Moins de grilles, plus de logique',
        description: 'Optimisez vos chances sans multiplier les tickets.'
      },
      feature5: {
        title: 'Simplicité',
        description: 'Vous recevez tout par mail, sans plateforme, sans friction.'
      },
      feature6: {
        title: 'Votre grille en un clic',
        description: 'Recevez votre grille optimisée et prête à être validée.'
      },
      cta: 'Prêt à jouer plus malin ?'
    },
    stats: {
      title: 'Des chiffres qui parlent pour nous.',
      subtitle: 'Des milliers de joueurs, des centaines de milliers de grilles générées, et une seule constante : une méthode statistique solide, fiable, et validée chaque semaine par les résultats.',
      stat1: {
        value: '+100 000',
        label: 'Grilles Générées'
      },
      stat2: {
        value: '97%',
        label: 'De satisfaction'
      },
      stat3: {
        value: '+70%',
        label: 'Abonnements renouvelés'
      },
      stat4: {
        value: '0',
        label: 'Grille jouée au hasard'
      }
    },
    finalCta: {
      title: 'Testez ProbaWins dès aujourd\'hui. Une seule grille peut changer votre vie.',
      subtitle: 'Testez une grille EuroMillions optimisée, sans engagement.',
      description: 'Basée sur notre algorithme statistique exclusif, cette grille a été calculée pour optimiser vos chances dès le prochain tirage EuroMillions',
      cta: 'Je tente ma chance pour un tirage',
      seeOffers: 'Voir les autres formules'
    },
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Une question ? Nous sommes là pour vous répondre.',
      form: {
        name: 'Nom',
        email: 'Email',
        message: 'Message',
        submit: 'Envoyer',
        success: 'Message envoyé avec succès !',
        error: 'Erreur lors de l\'envoi du message.'
      }
    },
    offers: {
      heroTitle: 'Choisissez la formule adaptée à votre tirage – et à vos ambitions',
      heroSubtitle: 'Quel que soit votre budget, vous méritez une grille optimisée.',
      heroDescription: 'Chez ProbaWins, chaque grille est générée par un algorithme statistique exclusif. Nos formules s\'adaptent à vos envies et à votre rythme : testez une seule grille pour un tirage… ou maximisez vos chances sur la durée.',
      periodMonthly: 'mensuellement',
      periodOneTime: 'Paiement unique',
      bestSeller: 'Best Seller',
      packs: {
        chance: {
          name: 'Chance Immédiate',
          description: 'Idéal pour tester notre méthode sans engagement.',
          price: '29,99',
          period: 'one_time',
          features: [
            '2 probabilités optimisées pour le prochain tirage EuroMillions.',
            'Parfait pour découvrir l\'efficacité de nos calculs.',
            'Une seule fois. Sans engagement.',
            'Support client 7/7j'
          ],
          cta: 'Je tente ma chance pour un tirage'
        },
        starter: {
          name: 'Starter',
          description: 'Parfait pour débuter l\'aventure sans pression.',
          price: '19,99',
          period: 'monthly',
          features: [
            '1 grille optimisée chaque semaine',
            'Tirage au choix : mardi ou vendredi',
            'Sans aucun engagement',
            'Support client 7/7j'
          ],
          cta: 'Démarrer'
        },
        premium: {
          name: 'Premium',
          description: 'Conçu pour les joueurs réguliers et sérieux.',
          price: '49,99',
          period: 'monthly',
          popular: true,
          features: [
            '4 grilles optimisées chaque semaine',
            '2 grilles le mardi + 2 grilles le vendredi',
            'Accès au Club ProbaWins',
            'Support client 7/7j'
          ],
          cta: 'Le meilleur choix'
        },
        vip: {
          name: 'VIP Max',
          description: 'Pensé pour les passionnés qui veulent tout maximiser.',
          price: '69,99',
          period: 'monthly',
          features: [
            '6 grilles optimisées chaque semaine',
            '3 grilles le mardi + 3 grilles le vendredi',
            'Accès au Club ProbaWins',
            'Support client 7/7j'
          ],
          cta: 'Maximiser'
        }
      },
      whyTitle: 'Pourquoi choisir Club ProbaWins ?',
      whySubtitle: 'Maximisez vos chances à l\'EuroMillions avec une méthode simple, efficace et sans engagement.',
      whyItems: [
        { title: 'Méthode statistique éprouvée', description: 'Chaque grille est générée d\'un algorithme conçu pour identifier les meilleures combinaisons.' },
        { title: 'Méthode simple à suivre', description: 'Pas besoin d\'être un expert en chiffres : on vous envoie vos grilles optimisées, prêtes à jouer.' },
        { title: 'Sans engagement, sans stress', description: 'Nos formules sont 100 % flexibles. Stoppez et reprenez quand vous voulez, en un clic.' },
        { title: 'Paiement 100% sécurisé', description: 'Vos transactions sont protégées via CB ou virement. Aucun risque, aucune surprise.' },
        { title: 'Accès au Club ProbaWins', description: 'Rejoignez une communauté de joueurs futés. Bénéficiez d\'analyses, d\'astuces et d\'un accompagnement privilégié.' },
        { title: 'Support humain 7j/7, sans robot', description: 'On vous répond rapidement, avec bienveillance et clarté. Un vrai humain est toujours là pour vous accompagner.' }
      ],
      faqTitle: 'Questions Fréquentes',
      faqSubtitle: '👉 Toutes les réponses à vos questions avant de rejoindre le Club ProbaWins.',
      faq: [
        { q: 'Quelle est la différence entre les offres Starter, Premium et VIP Max ?', a: 'Chaque formule se distingue par le nombre de grilles optimisées envoyées chaque semaine. Starter convient aux débutants (1 grille/semaine), Premium aux joueurs réguliers (4 grilles/semaine), et VIP Max aux passionnés qui veulent tout maximiser (6 grilles/semaine). Toutes les offres sont sans engagement.' },
        { q: 'Est-ce que je peux tester Club ProbaWins sans abonnement ?', a: 'Oui ! Le Pack Chance Immédiate à 29,99 € vous permet de recevoir 2 probabilités optimisées pour le prochain tirage. Idéal pour tester notre méthode sans vous engager.' },
        { q: 'Puis-je arrêter mon abonnement à tout moment ?', a: 'Bien sûr. Tous nos abonnements sont sans engagement. Vous pouvez résilier quand vous le souhaitez en nous contactant directement.' },
        { q: 'Quels sont les modes de paiement acceptés ?', a: 'Nous acceptons uniquement les prélèvements par carte bancaire (CB) ou RIB (mandat SEPA).' },
        { q: 'Quand vais-je recevoir mes grilles optimisées après achat ?', a: 'Vos grilles sont envoyées par e-mail chaque semaine, en fonction du ou des tirages sélectionnés (le mardi et/ou le vendredi selon la formule choisie).' },
        { q: 'Est-ce que vous jouez les grilles à ma place ?', a: 'Non. Chez Club ProbaWins, nous ne jouons jamais à votre place. Vous recevez des grilles optimisées à valider vous-même sur la plateforme de jeu de votre choix ou chez votre buraliste habituel.' },
        { q: 'Combien de temps minimum est recommandé pour constater des résultats ?', a: 'Nous recommandons un minimum de 3 mois d\'abonnement pour bien évaluer l\'efficacité des grilles optimisées. Le hasard reste présent, mais sur le long terme, les probabilités font la différence.' }
      ]
    },
    footer: {
      question: 'Une question?',
      rights: '© 2025 ProbaWins. Tous droits réservés.',
      legal: 'Mentions légales',
      privacy: 'Politique de confidentialité',
      terms: 'Conditions générales'
    }
  },
  es: {
    nav: {
      home: 'Inicio',
      howItWorks: '¿Cómo funciona?',
      offers: 'Nuestras ofertas',
      about: 'Acerca de',
      contact: 'Contacto',
      cta: 'Me Uno al Club ProbaWins'
    },
    logo: {
      tagline: 'Juega inteligente'
    },
    hero: {
      title: 'EuroMillones: No juegues más al azar, juega inteligente con ProbaWins',
      subtitle: 'La suerte sonríe a quienes dominan las estadísticas.',
      description: 'En ProbaWins, no vendemos sueños, te damos cuadrículas optimizadas, basadas en métodos fiables.',
      tagline: 'La suerte se calcula, entonces ¿por qué esperar?',
      cta: 'Descubro mi estrategia ganadora'
    },
    section1: {
      title: 'Controla tus juegos como un profesional, con los datos correctos.',
      subtitle: 'Sigue los últimos sorteos, refina tus cuadrículas y toma decisiones basadas en estadísticas, no en la suerte.',
      feature1: 'Cada cuadrícula tiene una lógica. Nuestro sistema analiza los sorteos pasados para seleccionar las combinaciones con más potencial.',
      feature2: 'Cuadrículas optimizadas entregadas cada semana en tu buzón. Recibe automáticamente tus combinaciones listas para jugar',
      feature3: 'Una solución simple, fiable y sin compromiso para los jugadores que quieren maximizar sus posibilidades.'
    },
    testimonials: {
      title: 'Apostaron por los números. Ya no juegan al azar',
      subtitle: 'Jugadores exigentes, racionales o curiosos. Todos encontraron en ProbaWins un método que cambia las reglas del juego.',
      testimonial1: {
        text: 'Es simple: disfruto más, porque juego con la cabeza. Y ya no desperdicio mis cuadrículas.',
        name: 'Nadine',
        role: 'Jubilada'
      },
      testimonial2: {
        text: 'Era escéptico, lo probé, cambié de opinión. ProbaWins es anti-azar. ¡Confiemos en los números!',
        name: 'Jean',
        role: 'Banquero'
      },
      testimonial3: {
        text: 'Este servicio me devolvió las ganas de probar suerte... pero esta vez, con posibilidades reales.',
        name: 'Jenni',
        role: 'Secretaria'
      },
      testimonial4: {
        text: 'Me gusta optimizar. En mi negocio como en mis juegos. ProbaWins cumple todos los requisitos.',
        name: 'Mathias',
        role: 'Empresario'
      },
      testimonial5: {
        text: 'Entendí que si quería ganar más, debía jugar mejor. Su método me impresionó.',
        name: 'Nicole',
        role: 'Ama de casa'
      }
    },
    testOffer: {
      title: 'Prueba ProbaWins en un sorteo — y juzga por ti mismo.',
      description: 'Recibe tu cuadrícula optimizada para el próximo sorteo de EuroMillones, generada según nuestras probabilidades exclusivas. Sin suscripción, sin compromiso: solo una prueba, y números que hablan.',
      amount: '29.99',
      currency: '€',
      cta: 'Pruebo mi suerte en un sorteo'
    },
    howItWorks: {
      title: 'Estadísticas. Precisión. Resultados.',
      subtitle: 'En 3 simples pasos, pasa de jugador a estratega. ProbaWins te guía para jugar más inteligente – se acabó el azar. De todas formas, vas a jugar. Mejor hacerlo inteligentemente.',
      step1: {
        title: 'Elige tu pack',
        description: '¿Prueba de un sorteo único o suscripción? Tú decides. Nosotros preparamos tus mejores cuadrículas.'
      },
      step2: {
        title: 'Recibe tus cuadrículas optimizadas',
        description: 'Combinaciones calculadas a partir de miles de sorteos. Entregadas por correo electrónico, listas para jugar.'
      },
      step3: {
        title: 'Juega con método (y serenidad)',
        description: 'Cada cuadrícula se basa en una estrategia real. Sin improvisación, solo lógica. Y mucho más placer al jugar.'
      },
      cta: 'Elijo mi estrategia'
    },
    emailSection: {
      title: 'Cada semana, tus cuadrículas directamente en tu buzón.',
      description: 'Sin app, sin login. Recibes nuestras mejores probabilidades, listas para jugar. Donde sea que estés, en cualquier dispositivo.'
    },
    whyChoose: {
      title: 'Por qué cientos de jugadores eligen ProbaWins cada semana.',
      subtitle: 'Ya juegas. Mejor hacerlo con método, sin perder tiempo ni dinero. ProbaWins simplifica todo para que cada cuadrícula realmente cuente.',
      feature1: {
        title: 'Método Probabilístico',
        description: 'Se basa en análisis fiables y serios.'
      },
      feature2: {
        title: 'Entrega cada semana',
        description: 'Los martes y/o viernes según la oferta elegida.'
      },
      feature3: {
        title: 'Sin compromiso',
        description: 'El mínimo recomendado es de 3 meses, pero eres libre de parar en cualquier momento.'
      },
      feature4: {
        title: 'Menos cuadrículas, más lógica',
        description: 'Optimiza tus posibilidades sin multiplicar los boletos.'
      },
      feature5: {
        title: 'Simplicidad',
        description: 'Recibes todo por correo, sin plataforma, sin fricción.'
      },
      feature6: {
        title: 'Tu cuadrícula en un clic',
        description: 'Recibe tu cuadrícula optimizada y lista para validar.'
      },
      cta: '¿Listo para jugar más inteligente?'
    },
    stats: {
      title: 'Cifras que hablan por nosotros.',
      subtitle: 'Miles de jugadores, cientos de miles de cuadrículas generadas, y una sola constante: un método estadístico sólido, fiable y validado cada semana por los resultados.',
      stat1: {
        value: '+100 000',
        label: 'Cuadrículas Generadas'
      },
      stat2: {
        value: '97%',
        label: 'De satisfacción'
      },
      stat3: {
        value: '+70%',
        label: 'Suscripciones renovadas'
      },
      stat4: {
        value: '0',
        label: 'Cuadrícula jugada al azar'
      }
    },
    finalCta: {
      title: 'Prueba ProbaWins hoy. Una sola cuadrícula puede cambiar tu vida.',
      subtitle: 'Prueba una cuadrícula EuroMillones optimizada, sin compromiso.',
      description: 'Basada en nuestro algoritmo estadístico exclusivo, esta cuadrícula ha sido calculada para optimizar tus posibilidades en el próximo sorteo de EuroMillones',
      cta: 'Pruebo mi suerte en un sorteo',
      seeOffers: 'Ver otras fórmulas'
    },
    contact: {
      title: 'Contáctanos',
      subtitle: '¿Una pregunta? Estamos aquí para responderte.',
      form: {
        name: 'Nombre',
        email: 'Correo electrónico',
        message: 'Mensaje',
        submit: 'Enviar',
        success: '¡Mensaje enviado con éxito!',
        error: 'Error al enviar el mensaje.'
      }
    },
    offers: {
      heroTitle: 'Elige la fórmula adaptada a tu sorteo – y a tus ambiciones',
      heroSubtitle: 'Sea cual sea tu presupuesto, mereces una cuadrícula optimizada.',
      heroDescription: 'En ProbaWins, cada cuadrícula es generada por un algoritmo estadístico exclusivo. Nuestras fórmulas se adaptan a tus deseos y a tu ritmo.',
      periodMonthly: 'mensualmente',
      periodOneTime: 'Pago único',
      bestSeller: 'Más Vendido',
      packs: {
        chance: { name: 'Suerte Inmediata', description: 'Ideal para probar nuestro método sin compromiso.', price: '29,99', period: 'one_time', features: ['2 probabilidades optimizadas para el próximo sorteo EuroMillones.', 'Perfecto para descubrir la eficacia de nuestros cálculos.', 'Una sola vez. Sin compromiso.', 'Atención al cliente 7/7'], cta: 'Pruebo mi suerte' },
        starter: { name: 'Starter', description: 'Perfecto para empezar la aventura sin presión.', price: '19,99', period: 'monthly', features: ['1 cuadrícula optimizada cada semana', 'Sorteo a elegir: martes o viernes', 'Sin compromiso', 'Atención al cliente 7/7'], cta: 'Empezar' },
        premium: { name: 'Premium', description: 'Diseñado para jugadores regulares y serios.', price: '49,99', period: 'monthly', popular: true, features: ['4 cuadrículas optimizadas cada semana', '2 cuadrículas martes + 2 viernes', 'Acceso al Club ProbaWins', 'Atención al cliente 7/7'], cta: 'La mejor opción' },
        vip: { name: 'VIP Max', description: 'Pensado para apasionados que quieren maximizar todo.', price: '69,99', period: 'monthly', features: ['6 cuadrículas optimizadas cada semana', '3 cuadrículas martes + 3 viernes', 'Acceso al Club ProbaWins', 'Atención al cliente 7/7'], cta: 'Maximizar' }
      },
      whyTitle: '¿Por qué elegir Club ProbaWins?',
      whySubtitle: 'Maximiza tus posibilidades en EuroMillones con un método simple, eficaz y sin compromiso.',
      whyItems: [
        { title: 'Método estadístico probado', description: 'Cada cuadrícula se genera con un algoritmo diseñado para identificar las mejores combinaciones.' },
        { title: 'Método simple de seguir', description: 'No necesitas ser un experto: te enviamos tus cuadrículas optimizadas, listas para jugar.' },
        { title: 'Sin compromiso, sin estrés', description: 'Nuestras fórmulas son 100% flexibles. Para y reanuda cuando quieras.' },
        { title: 'Pago 100% seguro', description: 'Tus transacciones están protegidas. Sin riesgos.' },
        { title: 'Acceso al Club ProbaWins', description: 'Únete a una comunidad de jugadores astutos.' },
        { title: 'Soporte humano 7/7, sin robot', description: 'Te respondemos rápidamente, con amabilidad y claridad.' }
      ],
      faqTitle: 'Preguntas Frecuentes',
      faqSubtitle: '👉 Todas las respuestas antes de unirte al Club ProbaWins.',
      faq: [
        { q: '¿Cuál es la diferencia entre Starter, Premium y VIP Max?', a: 'Cada fórmula se distingue por el número de cuadrículas optimizadas enviadas cada semana. Starter (1/semana), Premium (4/semana), VIP Max (6/semana). Todas sin compromiso.' },
        { q: '¿Puedo probar Club ProbaWins sin suscripción?', a: 'Sí. El Pack Suerte Inmediata a 29,99 € te permite recibir 2 probabilidades optimizadas para el próximo sorteo.' },
        { q: '¿Puedo cancelar mi suscripción en cualquier momento?', a: 'Por supuesto. Todas nuestras suscripciones son sin compromiso.' },
        { q: '¿Qué métodos de pago aceptan?', a: 'Aceptamos únicamente tarjeta bancaria o SEPA.' },
        { q: '¿Cuándo recibiré mis cuadrículas optimizadas?', a: 'Tus cuadrículas se envían por email cada semana, según los sorteos elegidos.' },
        { q: '¿Juegan las cuadrículas por mí?', a: 'No. Recibes las cuadrículas para validarlas tú mismo.' },
        { q: '¿Cuánto tiempo mínimo recomendado?', a: 'Recomendamos un mínimo de 3 meses para evaluar la eficacia.' }
      ]
    },
    footer: {
      question: '¿Una pregunta?',
      rights: '© 2025 ProbaWins. Todos los derechos reservados.',
      legal: 'Aviso legal',
      privacy: 'Política de privacidad',
      terms: 'Términos y condiciones'
    }
  },
  en: {
    nav: { home: 'Home', howItWorks: 'How it works?', offers: 'Our offers', about: 'About', contact: 'Contact', cta: 'Join ProbaWins Club' },
    logo: { tagline: 'Play smart' },
    hero: { title: 'EuroMillions: Stop playing randomly, play smart with ProbaWins', subtitle: 'Luck smiles on those who master statistics.', description: "At ProbaWins, we don't sell dreams, we give you optimized grids.", tagline: 'Luck can be calculated, so why wait?', cta: 'Discover my winning strategy' },
    section1: { title: 'Control your games like a pro.', subtitle: 'Follow the latest draws and make decisions based on statistics.', feature1: 'Every grid has logic.', feature2: 'Optimized grids delivered weekly.', feature3: 'Simple and reliable solution.' },
    testimonials: { title: 'They bet on numbers', subtitle: 'All found in ProbaWins a game-changing method.', testimonial1: { text: "I enjoy more because I play smart.", name: 'Nadine', role: 'Retired' }, testimonial2: { text: "ProbaWins is anti-random!", name: 'Jean', role: 'Banker' }, testimonial3: { text: 'This service gave me hope.', name: 'Jenni', role: 'Secretary' }, testimonial4: { text: 'ProbaWins checks all boxes.', name: 'Mathias', role: 'Entrepreneur' }, testimonial5: { text: 'Their method impressed me.', name: 'Nicole', role: 'Housewife' } },
    testOffer: { title: 'Test ProbaWins on one draw', description: 'Receive your optimized grid.', amount: '29.99', currency: '€', cta: 'I try my luck' },
    howItWorks: { title: 'Statistics. Precision. Results.', subtitle: 'In 3 simple steps.', step1: { title: 'Choose your pack', description: 'We prepare your best grids.' }, step2: { title: 'Receive your grids', description: 'Delivered by email.' }, step3: { title: 'Play with method', description: 'Based on real strategy.' }, cta: 'I choose my strategy' },
    emailSection: { title: 'Every week, your grids in your inbox.', description: 'No app, no login.' },
    whyChoose: { title: 'Why choose ProbaWins', subtitle: 'ProbaWins simplifies everything.', feature1: { title: 'Probabilistic Method', description: 'Reliable analyses.' }, feature2: { title: 'Weekly delivery', description: 'Tuesday and Friday.' }, feature3: { title: 'No commitment', description: 'Free to stop anytime.' }, feature4: { title: 'Less grids, more logic', description: 'Optimize chances.' }, feature5: { title: 'Simplicity', description: 'Everything by email.' }, feature6: { title: 'One click grid', description: 'Ready to validate.' }, cta: 'Ready to play smarter?' },
    stats: { title: 'Numbers speak for us.', subtitle: 'Thousands of players.', stat1: { value: '+100,000', label: 'Grids' }, stat2: { value: '97%', label: 'Satisfaction' }, stat3: { value: '+70%', label: 'Renewals' }, stat4: { value: '0', label: 'Random' } },
    finalCta: { title: 'Test ProbaWins today.', subtitle: 'Test optimized grid.', description: 'Based on our algorithm.', cta: 'I try my luck', seeOffers: 'See other formulas' },
    contact: { title: 'Contact us', subtitle: 'We are here.', form: { name: 'Name', email: 'Email', message: 'Message', submit: 'Send', success: 'Sent!', error: 'Error.' } },
    offers: {
      heroTitle: 'Choose the formula that fits your draw – and your ambitions',
      heroSubtitle: 'Whatever your budget, you deserve an optimized grid.',
      heroDescription: 'At ProbaWins, each grid is generated by an exclusive statistical algorithm. Our formulas adapt to your wishes and pace.',
      periodMonthly: 'monthly', periodOneTime: 'One-time payment', bestSeller: 'Best Seller',
      packs: {
        chance: { name: 'Instant Chance', description: 'Ideal to test our method without commitment.', price: '29.99', period: 'one_time', features: ['2 optimized probabilities for the next EuroMillions draw.', 'Perfect to discover the effectiveness of our calculations.', 'One time only. No commitment.', '7/7 customer support'], cta: 'I try my luck for one draw' },
        starter: { name: 'Starter', description: 'Perfect to start the adventure without pressure.', price: '19.99', period: 'monthly', features: ['1 optimized grid each week', 'Draw of your choice: Tuesday or Friday', 'No commitment', '7/7 customer support'], cta: 'Start' },
        premium: { name: 'Premium', description: 'Designed for regular and serious players.', price: '49.99', period: 'monthly', popular: true, features: ['4 optimized grids each week', '2 grids on Tuesday + 2 on Friday', 'Access to ProbaWins Club', '7/7 customer support'], cta: 'The best choice' },
        vip: { name: 'VIP Max', description: 'Designed for enthusiasts who want to maximize everything.', price: '69.99', period: 'monthly', features: ['6 optimized grids each week', '3 grids on Tuesday + 3 on Friday', 'Access to ProbaWins Club', '7/7 customer support'], cta: 'Maximize' }
      },
      whyTitle: 'Why choose ProbaWins Club?',
      whySubtitle: 'Maximize your EuroMillions chances with a simple, effective and no-commitment method.',
      whyItems: [
        { title: 'Proven statistical method', description: 'Each grid is generated by an algorithm designed to identify the best combinations.' },
        { title: 'Simple method to follow', description: 'No need to be a numbers expert: we send you optimized grids, ready to play.' },
        { title: 'No commitment, no stress', description: 'Our formulas are 100% flexible. Stop and resume whenever you want.' },
        { title: '100% secure payment', description: 'Your transactions are protected via card or transfer.' },
        { title: 'Access to ProbaWins Club', description: 'Join a community of smart players. Benefit from analyses and tips.' },
        { title: 'Human support 7/7, no robot', description: 'We answer quickly, kindly and clearly. A real human is always there.' }
      ],
      faqTitle: 'Frequently Asked Questions', faqSubtitle: '👉 All answers to your questions before joining ProbaWins Club.',
      faq: [
        { q: 'What is the difference between Starter, Premium and VIP Max?', a: 'Each formula is distinguished by the number of optimized grids sent each week. Starter (1/week), Premium (4/week), VIP Max (6/week). All without commitment.' },
        { q: 'Can I test ProbaWins Club without a subscription?', a: 'Yes! The Instant Chance Pack at €29.99 lets you receive 2 optimized probabilities for the next draw.' },
        { q: 'Can I stop my subscription anytime?', a: 'Of course. All our subscriptions are without commitment.' },
        { q: 'What payment methods are accepted?', a: 'We only accept bank card (CB) or SEPA direct debit.' },
        { q: 'When will I receive my grids after purchase?', a: 'Your grids are sent by email each week, based on the draws you selected.' },
        { q: 'Do you play the grids for me?', a: 'No. You receive optimized grids to validate yourself on the game platform of your choice.' },
        { q: 'How long minimum is recommended?', a: 'We recommend a minimum of 3 months of subscription to properly evaluate effectiveness.' }
      ]
    },
    footer: { question: 'A question?', rights: '© 2025 ProbaWins. All rights reserved.', legal: 'Legal', privacy: 'Privacy', terms: 'Terms' }
  },
  it: {
    nav: { home: 'Home', howItWorks: 'Come funziona?', offers: 'Offerte', about: 'Chi siamo', contact: 'Contatto', cta: 'Unisciti a ProbaWins' },
    logo: { tagline: 'Gioca intelligente' },
    hero: { title: 'EuroMillions: Gioca intelligente con ProbaWins', subtitle: 'La fortuna sorride a chi padroneggia le statistiche.', description: "Non vendiamo sogni, ti diamo griglie ottimizzate.", tagline: 'La fortuna si calcola!', cta: 'Scopro la strategia' },
    section1: { title: 'Controlla i tuoi giochi.', subtitle: 'Decisioni basate sulle statistiche.', feature1: 'Ogni griglia ha logica.', feature2: 'Griglie ottimizzate settimanali.', feature3: 'Soluzione semplice.' },
    testimonials: { title: 'Hanno scommesso sui numeri', subtitle: 'Metodo che cambia.', testimonial1: { text: "Gioco con la testa.", name: 'Nadine', role: 'Pensionata' }, testimonial2: { text: "Anti-caso!", name: 'Jean', role: 'Banchiere' }, testimonial3: { text: 'Mi ha dato speranza.', name: 'Jenni', role: 'Segretaria' }, testimonial4: { text: 'Perfetto.', name: 'Mathias', role: 'Imprenditore' }, testimonial5: { text: 'Impressionante.', name: 'Nicole', role: 'Casalinga' } },
    testOffer: { title: 'Prova ProbaWins', description: 'Ricevi griglia ottimizzata.', amount: '29.99', currency: '€', cta: 'Provo' },
    howItWorks: { title: 'Statistiche. Precisione. Risultati.', subtitle: 'In 3 passi.', step1: { title: 'Scegli pacchetto', description: 'Prepariamo griglie.' }, step2: { title: 'Ricevi griglie', description: 'Via email.' }, step3: { title: 'Gioca con metodo', description: 'Strategia reale.' }, cta: 'Scelgo strategia' },
    emailSection: { title: 'Ogni settimana, griglie nella casella.', description: 'Nessuna app.' },
    whyChoose: { title: 'Perché ProbaWins', subtitle: 'Semplifica tutto.', feature1: { title: 'Metodo Probabilistico', description: 'Analisi affidabili.' }, feature2: { title: 'Consegna settimanale', description: 'Martedì e venerdì.' }, feature3: { title: 'Nessun impegno', description: 'Libero sempre.' }, feature4: { title: 'Meno griglie, più logica', description: 'Ottimizza.' }, feature5: { title: 'Semplicità', description: 'Tutto via email.' }, feature6: { title: 'Un clic', description: 'Pronta.' }, cta: 'Pronto?' },
    stats: { title: 'Numeri per noi.', subtitle: 'Migliaia giocatori.', stat1: { value: '+100.000', label: 'Griglie' }, stat2: { value: '97%', label: 'Soddisfazione' }, stat3: { value: '+70%', label: 'Rinnovi' }, stat4: { value: '0', label: 'Casuali' } },
    finalCta: { title: 'Prova oggi.', subtitle: 'Griglia ottimizzata.', description: 'Algoritmo esclusivo.', cta: 'Provo', seeOffers: 'Altre formule' },
    contact: { title: 'Contattaci', subtitle: 'Siamo qui.', form: { name: 'Nome', email: 'Email', message: 'Messaggio', submit: 'Invia', success: 'Inviato!', error: 'Errore.' } },
    offers: {
      heroTitle: 'Scegli la formula adatta al tuo sorteggio – e alle tue ambizioni',
      heroSubtitle: 'Qualunque sia il tuo budget, meriti una griglia ottimizzata.',
      heroDescription: 'In ProbaWins ogni griglia è generata da un algoritmo statistico esclusivo. Le nostre formule si adattano ai tuoi desideri.',
      periodMonthly: 'mensile', periodOneTime: 'Pagamento unico', bestSeller: 'Più Venduto',
      packs: {
        chance: { name: 'Fortuna Immediata', description: 'Ideale per testare il nostro metodo senza impegno.', price: '29,99', period: 'one_time', features: ['2 probabilità ottimizzate per il prossimo sorteggio EuroMillions.', 'Perfetto per scoprire l\'efficacia dei nostri calcoli.', 'Una sola volta. Senza impegno.', 'Supporto clienti 7/7'], cta: 'Provo la mia fortuna' },
        starter: { name: 'Starter', description: 'Perfetto per iniziare l\'avventura senza pressione.', price: '19,99', period: 'monthly', features: ['1 griglia ottimizzata ogni settimana', 'Sorteggio a scelta: martedì o venerdì', 'Senza impegno', 'Supporto clienti 7/7'], cta: 'Iniziare' },
        premium: { name: 'Premium', description: 'Pensato per giocatori regolari e seri.', price: '49,99', period: 'monthly', popular: true, features: ['4 griglie ottimizzate ogni settimana', '2 griglie martedì + 2 venerdì', 'Accesso al Club ProbaWins', 'Supporto clienti 7/7'], cta: 'La scelta migliore' },
        vip: { name: 'VIP Max', description: 'Pensato per appassionati che vogliono massimizzare tutto.', price: '69,99', period: 'monthly', features: ['6 griglie ottimizzate ogni settimana', '3 griglie martedì + 3 venerdì', 'Accesso al Club ProbaWins', 'Supporto clienti 7/7'], cta: 'Massimizzare' }
      },
      whyTitle: 'Perché scegliere Club ProbaWins?', whySubtitle: 'Massimizza le tue possibilità con un metodo semplice ed efficace.',
      whyItems: [
        { title: 'Metodo statistico comprovato', description: 'Ogni griglia è generata da un algoritmo concepito per identificare le migliori combinazioni.' },
        { title: 'Metodo semplice', description: 'Non devi essere un esperto: ti inviamo le griglie ottimizzate pronte da giocare.' },
        { title: 'Senza impegno, senza stress', description: 'Le nostre formule sono 100% flessibili.' },
        { title: 'Pagamento 100% sicuro', description: 'Le transazioni sono protette.' },
        { title: 'Accesso al Club ProbaWins', description: 'Unisciti a una comunità di giocatori astuti.' },
        { title: 'Supporto umano 7/7', description: 'Rispondiamo rapidamente e con cortesia.' }
      ],
      faqTitle: 'Domande Frequenti', faqSubtitle: '👉 Tutte le risposte prima di unirti.',
      faq: [
        { q: 'Differenza tra Starter, Premium e VIP Max?', a: 'Si distinguono per il numero di griglie ottimizzate inviate ogni settimana. Starter (1), Premium (4), VIP Max (6). Tutti senza impegno.' },
        { q: 'Posso provare senza abbonamento?', a: 'Sì! Il Pack Fortuna Immediata a 29,99 € ti permette di ricevere 2 probabilità ottimizzate.' },
        { q: 'Posso cancellare in qualsiasi momento?', a: 'Certo. Tutti i nostri abbonamenti sono senza impegno.' },
        { q: 'Quali metodi di pagamento?', a: 'Accettiamo carta di credito o SEPA.' },
        { q: 'Quando riceverò le griglie?', a: 'Le griglie sono inviate via email ogni settimana.' },
        { q: 'Giocate al posto mio?', a: 'No. Ricevi le griglie e le valida tu stesso.' },
        { q: 'Quanto tempo minimo consigliato?', a: 'Raccomandiamo un minimo di 3 mesi per valutare l\'efficacia.' }
      ]
    },
    footer: { question: 'Domanda?', rights: '© 2025 ProbaWins. Tutti diritti.', legal: 'Legale', privacy: 'Privacy', terms: 'Termini' }
  },
  de: {
    nav: { home: 'Startseite', howItWorks: 'Wie funktioniert?', offers: 'Angebote', about: 'Über uns', contact: 'Kontakt', cta: 'ProbaWins beitreten' },
    logo: { tagline: 'Klug spielen' },
    hero: { title: 'EuroMillions: Clever spielen mit ProbaWins', subtitle: 'Glück lächelt Statistikmeistern.', description: "Wir geben optimierte Raster.", tagline: 'Glück berechnen!', cta: 'Strategie entdecken' },
    section1: { title: 'Steuern Sie Ihre Spiele.', subtitle: 'Statistikbasierte Entscheidungen.', feature1: 'Jedes Raster hat Logik.', feature2: 'Wöchentliche Raster.', feature3: 'Einfache Lösung.' },
    testimonials: { title: 'Sie setzten auf Zahlen', subtitle: 'Methode ändert alles.', testimonial1: { text: "Mit Kopf spielen.", name: 'Nadine', role: 'Rentnerin' }, testimonial2: { text: "Anti-Zufall!", name: 'Jean', role: 'Banker' }, testimonial3: { text: 'Gab mir Hoffnung.', name: 'Jenni', role: 'Sekretärin' }, testimonial4: { text: 'Perfekt.', name: 'Mathias', role: 'Unternehmer' }, testimonial5: { text: 'Beeindruckend.', name: 'Nicole', role: 'Hausfrau' } },
    testOffer: { title: 'ProbaWins testen', description: 'Optimiertes Raster erhalten.', amount: '29.99', currency: '€', cta: 'Ich versuche' },
    howItWorks: { title: 'Statistiken. Präzision. Ergebnisse.', subtitle: 'In 3 Schritten.', step1: { title: 'Paket wählen', description: 'Beste Raster.' }, step2: { title: 'Raster erhalten', description: 'Per E-Mail.' }, step3: { title: 'Mit Methode spielen', description: 'Echte Strategie.' }, cta: 'Strategie wählen' },
    emailSection: { title: 'Jede Woche Raster im Posteingang.', description: 'Keine App.' },
    whyChoose: { title: 'Warum ProbaWins', subtitle: 'Vereinfacht alles.', feature1: { title: 'Probabilistische Methode', description: 'Zuverlässig.' }, feature2: { title: 'Wöchentlich', description: 'Dienstag Freitag.' }, feature3: { title: 'Keine Verpflichtung', description: 'Jederzeit frei.' }, feature4: { title: 'Weniger Raster, mehr Logik', description: 'Optimieren.' }, feature5: { title: 'Einfachheit', description: 'Per E-Mail.' }, feature6: { title: 'Ein Klick', description: 'Bereit.' }, cta: 'Bereit?' },
    stats: { title: 'Zahlen sprechen.', subtitle: 'Tausende Spieler.', stat1: { value: '+100.000', label: 'Raster' }, stat2: { value: '97%', label: 'Zufriedenheit' }, stat3: { value: '+70%', label: 'Verlängerungen' }, stat4: { value: '0', label: 'Zufällig' } },
    finalCta: { title: 'Heute testen.', subtitle: 'Optimiertes Raster.', description: 'Exklusiver Algorithmus.', cta: 'Ich versuche', seeOffers: 'Andere Formeln' },
    contact: { title: 'Kontaktieren', subtitle: 'Wir sind hier.', form: { name: 'Name', email: 'E-Mail', message: 'Nachricht', submit: 'Senden', success: 'Gesendet!', error: 'Fehler.' } },
    offers: {
      heroTitle: 'Wählen Sie die passende Formel – für Ihre Ziehung und Ambitionen',
      heroSubtitle: 'Unabhängig von Ihrem Budget verdienen Sie ein optimiertes Raster.',
      heroDescription: 'Bei ProbaWins wird jedes Raster von einem exklusiven statistischen Algorithmus erzeugt.',
      periodMonthly: 'monatlich', periodOneTime: 'Einmalzahlung', bestSeller: 'Bestseller',
      packs: {
        chance: { name: 'Sofortglück', description: 'Ideal, um unsere Methode unverbindlich zu testen.', price: '29,99', period: 'one_time', features: ['2 optimierte Wahrscheinlichkeiten für die nächste EuroMillions-Ziehung.', 'Perfekt um die Effektivität zu entdecken.', 'Einmal. Unverbindlich.', '7/7 Kundenservice'], cta: 'Ich versuche mein Glück' },
        starter: { name: 'Starter', description: 'Perfekt um das Abenteuer entspannt zu beginnen.', price: '19,99', period: 'monthly', features: ['1 optimiertes Raster pro Woche', 'Ziehung Ihrer Wahl: Dienstag oder Freitag', 'Unverbindlich', '7/7 Kundenservice'], cta: 'Starten' },
        premium: { name: 'Premium', description: 'Für regelmäßige und ernsthafte Spieler.', price: '49,99', period: 'monthly', popular: true, features: ['4 optimierte Raster pro Woche', '2 Dienstag + 2 Freitag', 'Zugang zum ProbaWins Club', '7/7 Kundenservice'], cta: 'Beste Wahl' },
        vip: { name: 'VIP Max', description: 'Für Enthusiasten die alles maximieren wollen.', price: '69,99', period: 'monthly', features: ['6 optimierte Raster pro Woche', '3 Dienstag + 3 Freitag', 'Zugang zum ProbaWins Club', '7/7 Kundenservice'], cta: 'Maximieren' }
      },
      whyTitle: 'Warum ProbaWins Club wählen?', whySubtitle: 'Maximieren Sie Ihre Chancen mit einer einfachen, effektiven und unverbindlichen Methode.',
      whyItems: [
        { title: 'Bewährte statistische Methode', description: 'Jedes Raster wird von einem Algorithmus erzeugt, der die besten Kombinationen identifiziert.' },
        { title: 'Einfach zu verstehen', description: 'Sie müssen kein Zahlenexperte sein.' },
        { title: 'Unverbindlich, stressfrei', description: 'Unsere Formeln sind 100% flexibel.' },
        { title: '100% sichere Zahlung', description: 'Ihre Transaktionen sind geschützt.' },
        { title: 'Zugang zum ProbaWins Club', description: 'Werden Sie Teil einer Community kluger Spieler.' },
        { title: 'Menschlicher Support 7/7', description: 'Wir antworten schnell und freundlich.' }
      ],
      faqTitle: 'Häufige Fragen', faqSubtitle: '👉 Alle Antworten bevor Sie beitreten.',
      faq: [
        { q: 'Unterschied zwischen Starter, Premium und VIP Max?', a: 'Sie unterscheiden sich in der Anzahl optimierter Raster pro Woche. Starter (1), Premium (4), VIP Max (6). Alle unverbindlich.' },
        { q: 'Kann ich ohne Abo testen?', a: 'Ja! Das Sofortglück-Paket für 29,99 € bietet 2 optimierte Wahrscheinlichkeiten.' },
        { q: 'Kann ich jederzeit kündigen?', a: 'Natürlich. Alle Abos sind unverbindlich.' },
        { q: 'Welche Zahlungsmethoden?', a: 'Wir akzeptieren Kreditkarte oder SEPA.' },
        { q: 'Wann erhalte ich meine Raster?', a: 'Ihre Raster werden wöchentlich per E-Mail gesendet.' },
        { q: 'Spielen Sie für mich?', a: 'Nein. Sie erhalten die Raster und validieren sie selbst.' },
        { q: 'Empfohlene Mindestdauer?', a: 'Wir empfehlen mindestens 3 Monate.' }
      ]
    },
    footer: { question: 'Frage?', rights: '© 2025 ProbaWins. Alle Rechte.', legal: 'Impressum', privacy: 'Datenschutz', terms: 'Bedingungen' }
  },
  pt: {
    nav: { home: 'Início', howItWorks: 'Como funciona?', offers: 'Ofertas', about: 'Sobre', contact: 'Contato', cta: 'Junte-se ProbaWins' },
    logo: { tagline: 'Jogue esperto' },
    hero: { title: 'EuroMilhões: Jogue inteligente com ProbaWins', subtitle: 'A sorte sorri para quem domina estatísticas.', description: "Damos grades otimizadas.", tagline: 'Sorte se calcula!', cta: 'Descubro estratégia' },
    section1: { title: 'Controle seus jogos.', subtitle: 'Decisões baseadas em estatísticas.', feature1: 'Cada grade tem lógica.', feature2: 'Grades semanais.', feature3: 'Solução simples.' },
    testimonials: { title: 'Apostaram nos números', subtitle: 'Método que muda.', testimonial1: { text: "Jogo com cabeça.", name: 'Nadine', role: 'Aposentada' }, testimonial2: { text: "Anti-acaso!", name: 'Jean', role: 'Banqueiro' }, testimonial3: { text: 'Deu esperança.', name: 'Jenni', role: 'Secretária' }, testimonial4: { text: 'Perfeito.', name: 'Mathias', role: 'Empresário' }, testimonial5: { text: 'Impressionante.', name: 'Nicole', role: 'Dona de casa' } },
    testOffer: { title: 'Teste ProbaWins', description: 'Receba grade otimizada.', amount: '29.99', currency: '€', cta: 'Tento sorte' },
    howItWorks: { title: 'Estatísticas. Precisão. Resultados.', subtitle: 'Em 3 passos.', step1: { title: 'Escolha pacote', description: 'Melhores grades.' }, step2: { title: 'Receba grades', description: 'Por e-mail.' }, step3: { title: 'Jogue com método', description: 'Estratégia real.' }, cta: 'Escolho estratégia' },
    emailSection: { title: 'Toda semana, grades na caixa.', description: 'Sem app.' },
    whyChoose: { title: 'Por que ProbaWins', subtitle: 'Simplifica tudo.', feature1: { title: 'Método Probabilístico', description: 'Confiável.' }, feature2: { title: 'Entrega semanal', description: 'Terça sexta.' }, feature3: { title: 'Sem compromisso', description: 'Livre sempre.' }, feature4: { title: 'Menos grades, mais lógica', description: 'Otimize.' }, feature5: { title: 'Simplicidade', description: 'Por e-mail.' }, feature6: { title: 'Um clique', description: 'Pronta.' }, cta: 'Pronto?' },
    stats: { title: 'Números falam.', subtitle: 'Milhares jogadores.', stat1: { value: '+100.000', label: 'Grades' }, stat2: { value: '97%', label: 'Satisfação' }, stat3: { value: '+70%', label: 'Renovações' }, stat4: { value: '0', label: 'Aleatórias' } },
    finalCta: { title: 'Teste hoje.', subtitle: 'Grade otimizada.', description: 'Algoritmo exclusivo.', cta: 'Tento sorte', seeOffers: 'Outras fórmulas' },
    contact: { title: 'Contate-nos', subtitle: 'Estamos aqui.', form: { name: 'Nome', email: 'E-mail', message: 'Mensagem', submit: 'Enviar', success: 'Enviado!', error: 'Erro.' } },
    offers: {
      heroTitle: 'Escolha a fórmula adequada ao seu sorteio – e às suas ambições',
      heroSubtitle: 'Seja qual for seu orçamento, você merece uma grade otimizada.',
      heroDescription: 'Na ProbaWins, cada grade é gerada por um algoritmo estatístico exclusivo.',
      periodMonthly: 'mensal', periodOneTime: 'Pagamento único', bestSeller: 'Mais Vendido',
      packs: {
        chance: { name: 'Sorte Imediata', description: 'Ideal para testar nosso método sem compromisso.', price: '29,99', period: 'one_time', features: ['2 probabilidades otimizadas para o próximo sorteio EuroMilhões.', 'Perfeito para descobrir a eficácia.', 'Uma única vez. Sem compromisso.', 'Suporte ao cliente 7/7'], cta: 'Tento minha sorte' },
        starter: { name: 'Starter', description: 'Perfeito para começar sem pressão.', price: '19,99', period: 'monthly', features: ['1 grade otimizada por semana', 'Sorteio à escolha: terça ou sexta', 'Sem compromisso', 'Suporte ao cliente 7/7'], cta: 'Começar' },
        premium: { name: 'Premium', description: 'Para jogadores regulares e sérios.', price: '49,99', period: 'monthly', popular: true, features: ['4 grades otimizadas por semana', '2 grades terça + 2 sexta', 'Acesso ao Clube ProbaWins', 'Suporte ao cliente 7/7'], cta: 'Melhor escolha' },
        vip: { name: 'VIP Max', description: 'Para apaixonados que querem maximizar tudo.', price: '69,99', period: 'monthly', features: ['6 grades otimizadas por semana', '3 grades terça + 3 sexta', 'Acesso ao Clube ProbaWins', 'Suporte ao cliente 7/7'], cta: 'Maximizar' }
      },
      whyTitle: 'Por que escolher o Clube ProbaWins?', whySubtitle: 'Maximize suas chances com um método simples e eficaz.',
      whyItems: [
        { title: 'Método estatístico comprovado', description: 'Cada grade é gerada por um algoritmo concebido para identificar as melhores combinações.' },
        { title: 'Método simples', description: 'Não precisa ser um expert em números.' },
        { title: 'Sem compromisso, sem estresse', description: 'Nossas fórmulas são 100% flexíveis.' },
        { title: 'Pagamento 100% seguro', description: 'Suas transações são protegidas.' },
        { title: 'Acesso ao Clube ProbaWins', description: 'Junte-se a uma comunidade de jogadores espertos.' },
        { title: 'Suporte humano 7/7', description: 'Respondemos rapidamente com clareza.' }
      ],
      faqTitle: 'Perguntas Frequentes', faqSubtitle: '👉 Todas as respostas antes de se juntar.',
      faq: [
        { q: 'Diferença entre Starter, Premium e VIP Max?', a: 'Cada fórmula se distingue pelo número de grades otimizadas enviadas por semana. Starter (1), Premium (4), VIP Max (6). Todas sem compromisso.' },
        { q: 'Posso testar sem assinatura?', a: 'Sim! O Pack Sorte Imediata a 29,99 € permite receber 2 probabilidades otimizadas.' },
        { q: 'Posso cancelar a qualquer momento?', a: 'Claro. Todas as assinaturas são sem compromisso.' },
        { q: 'Quais métodos de pagamento?', a: 'Aceitamos cartão de crédito ou SEPA.' },
        { q: 'Quando receberei as grades?', a: 'As grades são enviadas por e-mail toda semana.' },
        { q: 'Vocês jogam por mim?', a: 'Não. Você recebe as grades para validar você mesmo.' },
        { q: 'Tempo mínimo recomendado?', a: 'Recomendamos no mínimo 3 meses.' }
      ]
    },
    footer: { question: 'Pergunta?', rights: '© 2025 ProbaWins. Todos direitos.', legal: 'Legal', privacy: 'Privacidade', terms: 'Termos' }
  }
};